import { z } from 'zod';

import { boardMemberInvitationStatusSchema as status } from './boardMemberInvitationStatusSchema';
import { minimumPasswordLengthSchema as minimumPasswordLength } from './minimumPasswordLengthSchema';

export const redeemBoardMemberInvitationContextSchema = z.object({
  status,
  minimumPasswordLength,
});
